import { InitialConfigType } from '@lexical/react/LexicalComposer';

export default function buildTheme(rootClass?: string): InitialConfigType['theme'] {
  return {
    root: ['editor-root', rootClass].filter(Boolean).join(' '),
    paragraph: 'editor-paragraph',
    text: {
      bold: 'editor-text-bold',
      italic: 'editor-text-italic',
      underline: 'editor-text-underline',
      strikethrough: 'editor-text-strikethrough',
      code: 'editor-text-code',
    },
    list: {
      nested: {
        listitem: 'editor-nested-listitem',
      },
      ol: 'editor-list-ol',
      ul: 'editor-list-ul',
      listitem: 'editor-listitem',
    },
    heading: {
      h1: 'editor-heading-h1',
      h2: 'editor-heading-h2',
      h3: 'editor-heading-h3',
      h4: 'editor-heading-h4',
      h5: 'editor-heading-h5',
      h6: 'editor-heading-h6',
    },
    quote: 'editor-quote',
    code: 'editor-code',
    link: 'editor-link',
    table: 'editor-table',
    tableCell: 'editor-table-cell',
    tableCellHeader: 'editor-table-cell-header',
    tableAddRows: 'editor-table-add-rows',
    tableAddColumns: 'editor-table-add-columns',
  };
}
